<template>
  <div id="container">
    <!-- 进度条区域开始-->
    <dv-border-box-3>
    <div id="gauge-content">

        <div id="planChart" ref="planChart_ref"></div>

    </div>
    </dv-border-box-3>
    <!-- 进度条区域结束-->
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ScwlWaybillDayChart',
    computed: {
      ...mapState('bigScreenData', ['waybillDayList'])
    },
    watch: {
      waybillDayList (val, old) {
        var plan_data1 = []
        var plan_xAxis = []
        for (let li of val) {
          plan_xAxis.push(li.distributionDate)
          plan_data1.push(li.waybillCount)
        }
        this.planOption.xAxis.data = plan_xAxis
        this.planOption.series[0].data = plan_data1

        this.planChart = this.$echarts.init(this.$refs.planChart_ref)

        this.planChart.setOption(this.planOption)

      },
    },
    data () {
      return {
        planChart: null,
        planOption: {
          xAxis: {
            data: null,
            axisLabel: {
              textStyle: {
                color: '#B7E1FF',
                fontSize: 10
              }
            },
            axisLine: {
              lineStyle: {
                color: '#09F'
              }
            },
            axisTick: {
              lineStyle: {
                color: '#09F'
              }
            }
          },
          yAxis: {
            inverse: false,
            splitArea: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              textStyle: {
                color: '#B7E1FF',
                fontSize: 10,
                fontFamily: 'Arial',
              }
            },
            splitLine: {
              lineStyle: {
                color: '#09F'
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            textStyle: {
              color: '#FFF',
              fontSize: 10
            }
          },
          grid: {
            left: 30,
            right: 20,
          },
          legend: {
            // show: false,
            top: 'top',
            textStyle: {
              color: '#fffff1',
              fontSize: 10
            },
            data: ['近30天日运单量']
          },
          series: [
            {
              name: '近30天日运单量',
              type: 'line',
              itemStyle: {
                normal: {
                  color: '#F90',
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#CCC',
                      fontSize: 10
                    }
                  },
                  lineStyle: {
                    color: '#F90',
                    width: 2
                  }
                },
                emphasis: {
                  color: '#FF0'
                }
              },
              symbolSize: 8,
              data: null
            }
          ]
        }
      }
    },
    created () {
    },
    mounted () {

    },
    methods: {}
  }
</script>

<style scoped>
  #container {
    width: 100%;
  }

  #gauge-content {
    color: #E1E1E1;
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    /*overflow: hidden;*/
    /*border: 1px solid beige;*/
    margin-left: 20px;
    align-content: center;
  }

  #planChart {
    width: 96%;
    height: 100%;
  }
</style>
